module.exports = __webpack_public_path__ + "static/banner-image-1-d08fa857c1fd6290bd69f1029ec95563.jpg";